// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__zqkUM","submitButton":"ContactForm_submitButton__KmKm9"};